module.exports = __webpack_public_path__ + "img/CS.8a40fca5.svg";